import { ROLE_OPTIONS, QUEUE_TYPE_OPTIONS, REGION_OPTIONS, RANK_OPTIONS_WITH_D2 } from "../common";

// ------------------------------------
//  ITEMS, SPELLS, RUNES
// ------------------------------------

export const ADV_BUILD_OPTIONS = {
  queueType: QUEUE_TYPE_OPTIONS,
  role: ROLE_OPTIONS,
  region: REGION_OPTIONS,
  rank: RANK_OPTIONS_WITH_D2,
  patch: { options: "latest", max: 5 },
};

export const ADV_BUILD_DEFAULT = {
  queueType: ADV_BUILD_OPTIONS.queueType[0].value,
  region: ADV_BUILD_OPTIONS.region[0].value,
  rank: ADV_BUILD_OPTIONS.rank[1].value,
  patch: ADV_BUILD_OPTIONS.patch.options,
};
